'use strict';

module.exports = [
    'timestamp', 'graphUnit', 'parent_name', 'name', 'plugins', 'features',
    'customer', 'ssidCountBuckets', 'locationCountBuckets', 'deviceCountBuckets',
    'portalCountBuckets', 'pluginCountBuckets'
];